"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailFinalClaimSchema = void 0;
var constants_1 = require("../../constants");
exports.detailFinalClaimSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'claimTypeCode',
        'contestedFlag',
        'evictionFlag',
        'interestAdjustmentDate',
        'legalActionStartedDate',
        'legalSystemTypeCode',
        'mobileHomeOnLeasedLandFlag',
        'mortgageTypeCode',
        'taxAccountBalanceTypeCode',
    ],
    properties: {
        additionalSecuritiesHeldByBorrowerTypeCode: {
            type: ['integer', 'null'],
            enum: __spreadArrays(Object.values(constants_1.AdditionalSecuritiesHeldByBorrower), [null]),
            errorMessage: 'should equate to a valid AdditionalSecuritiesHeldByBorrower Enum value or null',
        },
        britishColumbiaYukonSaleClosingDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format or null',
        },
        calendarDaysDeferredCount: {
            type: 'integer',
            minimum: 0,
            maximum: 180,
            errorMessage: 'should be numeric between 0 and 180',
        },
        claimFilingExtensionObtainedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be boolean',
        },
        claimTypeCode: {
            type: 'string',
            enum: Object.values(constants_1.ClaimTypeCode),
            errorMessage: 'should equate to a valid TypeOfClaim Enum value',
        },
        contestedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be boolean',
        },
        evictionFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be boolean',
        },
        interestAdjustmentDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format',
        },
        legalActionCompletedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format',
        },
        legalActionStartedDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format',
        },
        legalActionTypeCode: {
            type: ['integer', 'null'],
            enum: __spreadArrays(Object.values(constants_1.LegalActionType), [null]),
            errorMessage: 'should equate to a valid LegalActionType Enum value or null',
        },
        legalSystemTypeCode: {
            type: 'integer',
            enum: Object.values(constants_1.LegalSystemType),
            errorMessage: 'should equate to a valid LegalSystemType Enum value',
        },
        mobileHomeOnLeasedLandFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be boolean',
        },
        mortgageTypeCode: {
            type: 'integer',
            enum: Object.values(constants_1.MortgageType),
            errorMessage: 'should equate to a valid MortgageType Enum value',
        },
        offerAcceptedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format or null',
        },
        otherLegalActionTypeDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 60,
            errorMessage: 'should be a string with maximum of 60 characters or null',
        },
        propertyOccupancyStatusCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_1.PropertyOccupancyStatus), [null]),
            errorMessage: 'should be a valid PropertyOccupancyStatus Enum value or null',
        },
        propertySoldByTypeCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_1.PropertySoldBy), [null]),
            errorMessage: 'should equate to a valid PropertySoldBy Enum value or null',
        },
        propertyTransferredByTypeCode: {
            type: ['integer', 'null'],
            enum: __spreadArrays(Object.values(constants_1.PropertyTransferredBy), [null]),
            errorMessage: 'should equate to a valid PropertyTransferredBy Enum value or null',
        },
        propertyVacancyDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format or null',
        },
        propertyVacatedByTypeCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_1.PropertyVacatedBy), [null]),
            errorMessage: 'should equate to a valid PropertyVacatedBy Enum value or null',
        },
        representativeToObtainKey: {
            type: 'object',
            required: [],
            properties: {
                fullName: {
                    type: ['string', 'null'],
                    minLength: 0,
                    maxLength: 35,
                    errorMessage: 'should be a string with maximum of 35 characters or null',
                },
                phoneNumber: {
                    type: ['string', 'null'],
                    minLength: 10,
                    maxLength: 10,
                    errorMessage: 'should be a string with 10 characters or null',
                },
            },
        },
        taxAccountBalanceTypeCode: {
            type: 'integer',
            enum: Object.values(constants_1.TaxAccountBalanceType),
            errorMessage: 'should equate to a valid TaxAccountBalanceType Enum value or null',
        },
        warrantyTypeCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_1.WarrantyType), [null]),
            errorMessage: 'should equate to a valid WarrantyType Enum value or null',
        },
    },
};
